// extracted by mini-css-extract-plugin
module.exports = {"container":"Attribute_container__36Fyj","_0":"Attribute__0__1Q4-1","closeIcon":"Attribute_closeIcon__1BeF0"};